import { combineReducers } from 'redux';

import addresses from './addresses/reducer';

export default combineReducers({
  addresses,
});
